import "./pageLoaderComponent.scss";
import * as React from "react";

export interface PageLoaderProps {
    text?:string
}

const PageLoaderComponent = (props:PageLoaderProps) => {
    const {text= "Loading ..."} = props;

    return (
        <div className="loading-container">
            <div className="loading-spinner"></div>
            <div className="loading-text">{text}</div>
        </div>
    )
};

export default PageLoaderComponent;
